import actionTypes from '../constants/action-types';

const pageSettings = (state = {}, action) => {
  const { type, payload } = action;
  if (type === actionTypes.UPDATE_PAGE_SETTINGS && payload.pageId === state.id) {
    const { path } = payload.settings;
    const { path: currentPagePath } = state;

    if (path && path !== currentPagePath) {
      // provide trailing slash for path
      return {
        ...state,
        ...payload.settings,
        path: path.endsWith('/') ? path : `${path}/`,
      };
    }

    return {
      ...state,
      ...payload.settings,
    };
  }

  if (type === actionTypes.ADD_BINDING) {
    if (payload.pageId !== state.id) return state;
    return { ...state, bindings: [...(state.bindings || []), payload.binding] };
  }

  if (type === actionTypes.UPDATE_BINDING) {
    if (payload.pageId !== state.id) return state;
    return {
      ...state,
      bindings: (state.bindings || []).map((binding) =>
        binding.id === payload.bindingId ? { ...binding, ...payload.updates } : binding
      ),
    };
  }

  if (type === actionTypes.REMOVE_BINDING) {
    if (payload.pageId !== state.id) return state;
    return {
      ...state,
      bindings: (state.bindings || []).filter((binding) => binding.id !== payload.bindingId),
    };
  }

  return state;
};

export default pageSettings;
